import { ErrorBoundary } from '@/components/ErrorBoundary/ErrorBoundaryReactRouter';
import { convertRouteModule } from '@/utils/convert-route-module';
import { RouteObject } from 'react-router';

const glCodesModalRoutes: RouteObject[] = [
  {
    path: 'create',
    lazy: () =>
      import('@/views/payments/components/GlCodes/CreateGlCodeModal').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
  {
    path: 'import',
    lazy: () =>
      import('@/views/payments/components/GlCodes/ImportGlCodesModal').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
  {
    path: ':glCodeId/edit',
    lazy: () =>
      import('@/views/payments/components/GlCodes/EditGlCodeModal').then(convertRouteModule),
    ErrorBoundary,
    HydrateFallback: () => null,
  },
];

export { glCodesModalRoutes };
